module.exports = __webpack_public_path__ + "img/record.1a8f57d6.svg";